// @ts-nocheck
import { UPDATE_SUPPORT_CONTACT_ERROR, UPDATE_SUPPORT_CONTACT_LOADING, UPDATE_SUPPORT_CONTACT_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const updateSupportContact = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: UPDATE_SUPPORT_CONTACT_LOADING,
                data: true
            })
            Authservices.updateSupportContact(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: UPDATE_SUPPORT_CONTACT_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: UPDATE_SUPPORT_CONTACT_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}